const params = new Map(window.location.search.slice(1).split('&').map(kv => kv.split('=')));
let origin = decodeURIComponent(params.get("origin"));


function printSignatureReceipt(pollingResponse) {
    let message = JSON.stringify({
        "step": "PRINT",
        "receipt_html_extra": buildSignatureReceipt(pollingResponse)
    })
    window.parent.postMessage(message, origin || "https://storekitdemo.vendhq.com");

}



function buildSignatureReceipt(pollingResponse, showSignature) {
    let receiptHtml = `
            <div>
                <h3>Card Receipt</h3>
                <p>Auth Code: ${pollingResponse.data.result.auth_code}</p>
                <p>Txn Type: ${pollingResponse.data.result.transaction_type}</p>
                <p>Payment Method: ${pollingResponse.data.result.application_label}</p>
                <p>PAN: ${pollingResponse.data.result.primary_account_number}</p>
                <p>Cardholder Verification: ${pollingResponse.data.result.card_holder_verification_method} </p>
                <p>Application: ${pollingResponse.data.result.application_id} ${pollingResponse.data.result.application_label} </p>
            </div>`;

    if (showSignature) {
        receiptHtml = receiptHtml + `<div>
                                        <h3>Please Sign:</h3>
                                        <p>&nbsp;</p>
                                        <p>&nbsp;</p>
                                        <p>.......................</p>
        </div>`;
    }

    return receiptHtml;
}

export { printSignatureReceipt, buildSignatureReceipt }